import React from "react";
import { PreloadedQuery, usePreloadedQuery } from "react-relay";
import { graphql } from "relay-runtime";
import { NoteEdit } from "../../Storecast/Storecast/WidetNoteEdit/NoteEdit";
import { OrgSpaceNoteEditQuery } from "./__generated__/OrgSpaceNoteEditQuery.graphql";
import { useUploadWidgetNoteImageOrg } from "../../Storecast/Storecast/WidetNoteEdit/useSaveNoteImage";

export type { OrgSpaceNoteEditQuery };

export const ORG_SPACE_NOTE_EDIT_QUERY = graphql`
  query OrgSpaceNoteEditQuery($id: ID!) {
    widgetNote(id: $id) @required(action: THROW) {
      id
      positionY
      positionX
      note {
        ...NoteEditSharedInfo_widgetNote
        ...NoteEdit
      }
    }
  }
`;

export function OrgSpaceNoteEdit(props: {
  queryRef: PreloadedQuery<OrgSpaceNoteEditQuery>;
  workspaceId: string;
  pageId: string;
  onClosed(): void;
  onStart(): void;
  left: number;
  top: number;
  unitSize: number;
}) {
  const data = usePreloadedQuery(ORG_SPACE_NOTE_EDIT_QUERY, props.queryRef);

  const uploadImage = useUploadWidgetNoteImageOrg(props.workspaceId);

  return (
    <NoteEdit
      uploadImage={uploadImage}
      note={data.widgetNote.note}
      onClosed={props.onClosed}
      onStart={props.onStart}
      pageId={props.pageId}
      unitSize={props.unitSize}
      startLeft={props.left}
      startTop={props.top}
    />
  );
}
